import React from 'react';
import Icon from 'components/canvas/components/icon';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import EditIcon from 'styles/icons/risk.svg';

import EditGoldIcon from 'styles/icons/risk-gold.svg';

import { Rect, Text } from 'react-konva';
import { useCanvasStageScale } from 'state/canvas/stage';
import { useRiskMenuPositionOperation } from 'state/canvas/selected-risk';
import { throttle } from 'lodash';
import { Position } from 'types';

// import RiskIcon from 'styles/icons/risk.svg';
// import EditGoldIcon from 'styles/icons/calender-gold.svg';
// import DatePicker from 'react-datepicker';

// import 'react-datepicker/dist/react-datepicker.css';

function DummyRect(props: Position) {
  const ref = React.useRef<any>();

  const scale = useCanvasStageScale();

  const { setRiskMenuPosition } = useRiskMenuPositionOperation();

  React.useEffect(() => {
    showLinkMenu();
  }, [props.x, props.y, scale]);

  const showLinkMenu = throttle(() => {
    const linkMenuPosition = ref.current?.getAbsolutePosition();

    const offsetY = 100;

    if (linkMenuPosition) {
      const position = {
        x: linkMenuPosition.x,
        y: linkMenuPosition.y - offsetY * scale,
      };

      setRiskMenuPosition(position);
    }
  }, 150);

  return (
    <Rect
      ref={ref}
      width={400}
      height={50}
      x={props.x}
      y={props.y}
      scaleX={scale}
      scaleY={scale}
    />
  );
}

export interface SurfaceNodeEditIconProps {
  onClick?: Function;
  width?: number;
  height?: number;
}

// const Picker = () => {
//   const [startDate, setStartDate] = React.useState(new Date());
//   return (
//     <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
//   );
// };

const defaultProps = {};

function SurfaceNodeRiskIcon(props: SurfaceNodeEditIconProps) {
  const [isSelected, setSelected] = React.useState<boolean>(false);
  const { clearSelectedNode } = useSelectedNodeOperations();

  const src = isSelected ? EditGoldIcon : EditIcon;

  function onClick(event) {
    setSelected(true);
    event.cancleBubble = true;

    setTimeout(() => {
      props.onClick && props.onClick(event);
      // clearSelectedNode();
    }, 200);
  }

  return (
    <>
      <Icon
        {...props}
        onClick={onClick}
        src={src}
        // onMouseOver={() => setSelected(true)}
        // onMouseOut={() => setSelected(false)}
      />
      {/* {isSelected && <DummyRect x={arrowMiddle.x} y={arrowMiddle.y} />} */}
      {/* {isSelected && <Text>AAA</Text>} */}
      {/* <Picker></Picker> */}
    </>
  );
}

SurfaceNodeRiskIcon.defaultProps = defaultProps;

export default SurfaceNodeRiskIcon;
